"use strict";

import "../scss/style.scss";

// ⓪
import BarbaPjax from "./BarbaPjax.js";

// ①
import VanillaVisitedLoading from "./VanillaVisitedLoading.js";

// ②
import VanillaBgNoise from "./VanillaBgNoise.js";

// ③
import VanillaInview from "./VanillaInview.js";

// ④
import MouseParallax from "./MouseParallax.js";

// ⑤
import VanillaHeaderHidden from "./VanillaHeaderHidden.js";

// ⑥
import VanillaIvtnBoxFloating from "./VanillaIvtnBoxFloating.js";

// ⑦
import VanillaHoverAnimation from "./VanillaHoverAnimation.js";

// ⑧
import VanillaHoverScaleAnimation from "./VanillaHoverScaleAnimation.js";

// ⑨
import VanillaInvitationCircleHover from "./VanillaInvitationCircleHover.js";

// ⑩
import LoadingLottie from "./LoadingLottie.js";

// 11
import VanillaHeaderFieldsToggle from "./VanillaHeaderFieldsToggle.js";

// 12
import VanillaPageReload from "./VanillaPageReload.js";

// 13
import VanillaTextNoise from "./VanillaTextNoise.js";

// 14
import PrtsFldsQuestionSlider from "./PrtsFldsQuestionSlider.js";

// 15
import VanillaSmoothScroll from "./VanillaSmoothScroll.js";

// 16
import SimpleBarScroll from "./SimpleBarScroll.js";

// 17
import VanillaContactFormComplete from "./VanillaContactFormComplete.js";

// 18
import VanillaSticky from "./VanillaSticky.js";

let pageInstances = [];

function initGlobalScripts() {
  // ① 初回訪問判定
  new VanillaVisitedLoading();

  // ⑤ header表示制御
  new VanillaHeaderHidden("100", "12rem");

  // ⑥ footer invitation floating
  new VanillaIvtnBoxFloating("#js-ivtn-box", ".js-ivtn-box-itm", {
    minSpeed: 100,
    maxSpeed: 120,
    padding: 0,
    rotationRange: 18,
  });

  // ⑨ invitation circle hover
  new VanillaInvitationCircleHover();

  // ⑩ loading lottie
  new LoadingLottie();

  // 11 header fields toggle
  new VanillaHeaderFieldsToggle();

  // 12 page reload
  new VanillaPageReload();

  // 15 smooth scroll
  new VanillaSmoothScroll();

  // 18
  // Sticky / magnetic hover
  new VanillaSticky(".js-move", {
    strength: 0.4,
    ease: 0.16,
    maxMove: 24,
  });
}

function initPageScripts(container = document) {
  destroyPageScripts();

  pageInstances = [
    // ③ 先にInview系を初期化して、遷移後アニメーションを早く開始する
    new VanillaInview(
      ".js-inview-philosophy",
      "--is-inview-acv",
      {
        threshold: 1,
      },
      container,
    ),

    new VanillaInview(
      ".js-inview",
      "--is-inview-acv",
      {
        threshold: 0.5,
      },
      container,
    ),

    new VanillaInview(
      ".js-inview-imgs",
      "--is-inview-acv",
      {
        threshold: 0.1,
      },
      container,
    ),

    new VanillaInview(
      ".js-inview-list",
      "--is-inview-acv",
      {
        threshold: 0.1,
      },
      container,
    ),

    // footerがmain外なので、ここはdocument対象のままでOK
    new VanillaInview(".js-inview-footer-logo", "--is-inview-acv", {
      threshold: 0.75,
      once: false,
    }),

    // ② canvas系はInviewより後ろに回す
    new VanillaBgNoise(".js-noise-bg", {}, container),

    // ④
    new MouseParallax(".js-parallax", {}, container),

    // ⑦
    new VanillaHoverAnimation(".js-hover-animation"),

    // ⑧
    new VanillaHoverScaleAnimation(),

    // 13
    new VanillaTextNoise(".js-text-noise"),

    // 14
    new PrtsFldsQuestionSlider("#js-qstn-slider", {}, container),

    // 16
    new SimpleBarScroll(".js-simplebar"),

    // 17
    new VanillaContactFormComplete({}, container),
  ];
}

function destroyPageScripts() {
  if (!pageInstances.length) return;

  pageInstances.forEach((instance) => {
    if (!instance) return;

    if (typeof instance.destroyAll === "function") {
      instance.destroyAll();
      return;
    }

    if (typeof instance.destroy === "function") {
      instance.destroy();
    }
  });

  pageInstances = [];
}

function getBarbaContainer(event) {
  if (event.detail && event.detail.next && event.detail.next.container) {
    return event.detail.next.container;
  }

  return document;
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    initGlobalScripts();

    window.addEventListener(
      "barba:before-leave",
      () => {
        destroyPageScripts();
      },
      false,
    );

    window.addEventListener(
      "barba:page-ready",
      (event) => {
        const container = getBarbaContainer(event);

        initPageScripts(container);
      },
      false,
    );

    // 最後にBarbaを起動
    new BarbaPjax();
  },
  false,
);
